export class HttpResponse {
  esito: boolean;
  httpCode: string;
  returnCode: string;
  returnObjects: any[];
  okMessages: string[];
  koMessages: any[];
  exceptionMessage: string;
  operationTimeMs: number;
}
